import { status as Status } from '@bt-react/constants'

/** Determines whether the Questions polling should be enabled based on the gig status */
export default function (status: string): boolean {

  return status !== Status.UPCOMING && status !== Status.COMPLETE

}
